<template>
  <a-modal v-model="visible" :title="$t('科目列表')" width="1400px" @cancel="close" @ok="onOk">
    <AccountList
      ref="AccountListRef"
      :hasSelected="selectedRows"
      :showSelect="true"
      :params="mergedParams"
      @select="onSelect"
      @change="onChange"
    />
  </a-modal>
</template>

<script>
import AccountList from '@/view/baseInfo/accountList'
export default {
  props: {
    hasSelected: {
      type: Array,
      default: () => [],
    },
    single: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { AccountList },
  data() {
    return {
      visible: false,
      selectedRows: [],
      customParams: {},
    }
  },
  computed: {
    mergedParams() {
      return { ...this.params, ...this.customParams }
    },
  },
  methods: {
    open(params = {}) {
      this.selectedRows = this.hasSelected ? [...this.hasSelected] : []
      this.customParams = params
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.AccountListRef) {
          this.$refs.AccountListRef.getTableList(1)
        }
      })
    },
    close() {
      this.visible = false
    },
    onSelect(list) {
      if (this.single) {
        // 单选模式：只保留最后一个选中的项
        this.selectedRows = list.length > 0 ? [list[list.length - 1]] : []
      } else {
        // 多选模式：保留所有选中的项
        this.selectedRows = list
      }
    },
    onChange(data) {
      if (this.single) {
        // 单选模式：直接替换为当前选中的项
        this.selectedRows = [data]
      } else {
        // 多选模式：添加到列表中
        let index = this.selectedRows.findIndex((item) => item.code === data.code)
        if (index === -1) {
          this.selectedRows.push(data)
        }
      }
      this.onOk()
    },
    onOk() {
      this.close()
      // 单选模式时，确保只返回一个项
      const result =
        this.single && this.selectedRows.length > 0
          ? [this.selectedRows[this.selectedRows.length - 1]]
          : this.selectedRows
      this.$emit('ok', result)
    },
  },
}
</script>
